/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function CircleDashedIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="circle-dashed"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M21.274 9.939A9.5 9.5 0 0 1 21.274 14.061" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 9.5 9.5 347.471 12.529 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20.015 17.1A9.5 9.5 45 0 1 17.1 20.015" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 9.5 9.5 347.471 12.529 45 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M14.061 21.274A9.5 9.5 90 0 1 9.939 21.274" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 9.5 9.5 347.471 12.529 90 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M6.9 20.015A9.5 9.5 135 0 1 3.985 17.1" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 9.5 9.5 347.471 12.529 135 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M2.726 14.061A9.5 9.5 180 0 1 2.726 9.939" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 9.5 9.5 347.471 12.529 180 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.985 6.9A9.5 9.5 225 0 1 6.9 3.985" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 9.5 9.5 347.471 12.529 225 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M9.939 2.726A9.5 9.5 270 0 1 14.061 2.726" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 9.5 9.5 347.471 12.529 270 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M17.1 3.985A9.5 9.5 315 0 1 20.015 6.9" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 9.5 9.5 347.471 12.529 315 center" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
